import { FastFood } from "../../components";
import "./stylesCategoriaFastFood.scss";

export const CategoriaFastFood = () => (
  <div>
    <FastFood />
  </div>
);
